var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg02759CModified = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.21 142.21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: none;\r\n        stroke: currentcolor;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "long-distance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "optimizeQuality"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 71.11,
    cy: 71.11,
    r: 68.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 71.11,
    cy: 54.94,
    rx: 66.16,
    ry: 24.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 71.11,
    cy: 88.26,
    rx: 66.16,
    ry: 24.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 71.11,
    cy: 71.11,
    rx: 24.99,
    ry: 68.61
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg02759CModified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/02759~C-modified.3a7342403096545dd947f656bdb614bd.svg";